// 🔧 car_shows.js
// ✅ Purpose: Marketing landing page wrapper for car shows
// ✅ Features:
// - Pulls SEO and page content from centralized marketing_pages.js
// - Renders shared SEO-focused IndustryLandingPage template

import React from "react";
import IndustryLandingPage from "./industry_landing_page";
import { MARKETING_PAGES } from "../../constants/marketing_pages";

const CarShows = () => {
  return <IndustryLandingPage page={MARKETING_PAGES.carShows} />;
};

export default CarShows;